import React from 'react';
import Flickity from 'react-flickity-component';
var flickityOptions = {
  draggable: true,
  wrapAround: true,
  percentPosition: false,
  cellAlign: 0.001,
  contain: true,
  autoPlay: 5000
};

var BlogHero = function BlogHero(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "blog-hero"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement(Flickity, {
    className: "carousel",
    options: flickityOptions,
    reloadOnUpdate: true
  }, children)));
};

BlogHero.displayName = 'BlogHero';
var BlogHeroDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  BlogHeroDoc = require('./doc').doc(BlogHero);
}

var BlogHeroWrapper = BlogHeroDoc || BlogHero;
export { BlogHeroWrapper as BlogHero };